import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';

import addresses from '@/store/addresses';
import admin from '@/store/admin';
import alarms from '@/store/alarms';
import attributesSchema from '@/store/attributesSchema';
import authentication from '@/store/authentication';
import billings from '@/store/billings';
import changeHistory from '@/store/changeHistory';
import datasourceSettings from '@/store/datasourceSettings';
import edit from '@/store/edit';
import epanet from '@/store/epanet';
import externalSystems from '@/store/externalSystems';
import failures from '@/store/failures';
import hydrants from '@/store/hydrants';
import intercad from '@/store/intercad';
import investments from '@/store/investments';
import layers from '@/store/layers';
import lightingControl from '@/store/lightingControl';
import locks from '@/store/locks';
import map from '@/store/map';
import modeling from '@/store/modeling';
import modules from '@/store/modules';
import navbar from '@/store/navbar';
import nmt from '@/store/nmt';
import notes from '@/store/notes';
import scada from '@/store/scada';
import search from '@/store/search';
import sidebar from '@/store/sidebar';
import sms from '@/store/sms';
import snackbar from '@/store/snackbar';
import statistics from '@/store/statistics';
import styles from '@/store/styles';
import table from '@/store/table';
import tasks from '@/store/tasks';
import tools from '@/store/tools';
import users from '@/store/users';
import zdm from '@/store/zdm';
import zdmFailures from '@/store/zdmFailures';
import zdm_data from '@/store/zdm_data';
import zdm_inspectors from '@/store/zdm_inspectors';
import asyncStatusChecker from '@/store/asyncStatusChecker';
import locationLab from '@/store/locationLab';
import relations from '@/store/relations';
import watcher from '@/store/watcher';
import manholes from '@/store/manholes';
import zdmCustomReports from '@/store/zdmCustomReports';
import congestions from '@/store/congestions';
import celeryTasks from '@/store/celeryTasks';
import gtag from '@/store/gtag';
import waterBalance from '@/store/waterBalance';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [pathify.plugin],
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    addresses,
    admin,
    alarms,
    attributesSchema,
    authentication,
    billings,
    changeHistory,
    datasourceSettings,
    edit,
    epanet,
    externalSystems,
    failures,
    hydrants,
    intercad,
    investments,
    layers,
    lightingControl,
    locks,
    map,
    modeling,
    modules,
    navbar,
    nmt,
    notes,
    scada,
    search,
    sidebar,
    sms,
    snackbar,
    statistics,
    styles,
    table,
    tasks,
    tools,
    users,
    zdm,
    zdmFailures,
    zdm_data,
    zdm_inspectors,
    asyncStatusChecker,
    locationLab,
    relations,
    watcher,
    manholes,
    zdmCustomReports,
    congestions,
    celeryTasks,
    gtag,
    waterBalance,
  },
});
